// removed by extract-text-webpack-plugin
module.exports = {"printFooter":"printFooter__printFooter___2Gv46","creditsImage":"printFooter__creditsImage___181tn"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/footers/printFooter.css
// module id = 968
// module chunks = 0